import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { Field, RuleExpression } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidatableField',
  props: {
    name: null,
    as: { default: undefined },
    rules: null,
    label: { default: undefined },
    modelValue: { default: '' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {





const updateValue = (event: Event) => {
  const target = event.target as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
  emit('update:modelValue', target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Field), {
    name: __props.name,
    label: __props.label,
    rules: __props.rules,
    value: __props.modelValue
  }, {
    default: _withCtx(({ field, errorMessage }) => [
      (!__props.as || __props.as == 'input')
        ? (_openBlock(), _createElementBlock("input", _mergeProps({ key: 0 }, { ...field, ..._ctx.$attrs }, {
            class: { '--is-error': !!errorMessage },
            onInput: _cache[0] || (_cache[0] = ($event: any) => (updateValue($event)))
          }), null, 16))
        : (__props.as == 'textarea')
          ? (_openBlock(), _createElementBlock("textarea", _mergeProps({ key: 1 }, { ...field, ..._ctx.$attrs, value: field.value as string }, {
              class: { '--is-error': !!errorMessage },
              onInput: _cache[1] || (_cache[1] = ($event: any) => (updateValue($event)))
            }), null, 16))
          : (__props.as == 'select')
            ? (_openBlock(), _createElementBlock("select", _mergeProps({ key: 2 }, { ...field, ..._ctx.$attrs }, {
                class: { '--is-error': !!errorMessage },
                onChange: _cache[2] || (_cache[2] = ($event: any) => (updateValue($event)))
              }), [
                _renderSlot(_ctx.$slots, "default")
              ], 16))
            : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["name", "label", "rules", "value"]))
}
}

})